import api from '../store/api.ts';
import {unwrapData} from '../store/apiResponse.ts';
import {type ChatNotificationMute} from './chatNotificationMuteCache.ts';

export type ChatNotificationMuteDurationHours = 1 | 2 | 4 | 8 | 24;

export {
    type ChatNotificationMute,
    isChatNotificationMuteActive,
    isRoomChatNotificationMuted,
    nextChatNotificationMuteRefreshDelay,
    removeActiveRoomChatNotificationMute,
    replaceActiveChatNotificationMutes,
    setActiveRoomChatNotificationMute,
} from './chatNotificationMuteCache.ts';

export interface ChatNotificationMuteAccount {
    tenant: string;
    userId: string;
}

export const chatNotificationMuteApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getActiveChatNotificationMutes: builder.query<ChatNotificationMute[], ChatNotificationMuteAccount>({
            query: () => ({
                url: '/api/v1/chat-notification-mutes',
                method: 'GET',
            }),
            transformResponse: (response: {data: ChatNotificationMute[]}) => unwrapData(response),
            providesTags: ['ChatNotificationMutes'],
        }),
        muteChatRoom: builder.mutation<
            ChatNotificationMute,
            {roomId: string; durationHours: ChatNotificationMuteDurationHours}
        >({
            query: ({roomId, durationHours}) => ({
                url: `/api/v1/chat-notification-mutes/rooms/${encodeURIComponent(roomId)}`,
                method: 'PUT',
                body: {durationHours},
            }),
            transformResponse: (response: {data: ChatNotificationMute}) => unwrapData(response),
            invalidatesTags: ['ChatNotificationMutes'],
        }),
        unmuteChatRoom: builder.mutation<void, string>({
            query: (roomId) => ({
                url: `/api/v1/chat-notification-mutes/rooms/${encodeURIComponent(roomId)}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['ChatNotificationMutes'],
        }),
    }),
});

export const {
    useGetActiveChatNotificationMutesQuery,
    useMuteChatRoomMutation,
    useUnmuteChatRoomMutation,
} = chatNotificationMuteApi;
